<template>
	<div class="wrapper form">
		<div class="input-wrapper">
			<div class="input__title">Kockázatviselési cím:</div>
			<InputField :elements="fields.riskBearingAddress" />
		</div>
        <div class="input-wrapper" v-if="getRealEstate.type === 0 && getCalculation.has_condominium_insurance && getCalculation.condominium_insurer === 'ALF'">
            <div class="input__title">Tarásaház adatai:</div>
            <InputField :elements="fields.condominium" />
        </div>
		<div class="input-wrapper">
			<div class="input__title">Szerződő adatai:</div>
			<InputField :elements="fields.contractDetails" />
		</div>
		<div
			class="input-wrapper inline mb-20px"
			style="background-color: #f4f5f4"
			v-if="getCalculation.payment_method === 2"
		>
			<div class="input__title">Fizetési adatok:</div>
			<InputField :elements="fields.paymentDetails" />
		</div>
		<div class="input-wrapper no-p-top">
			<CalcElem
				name="differentPermanentAddress"
				:options="{
					label: 'A szerződő állandó lakcíme eltér a kockázatviselési címtől',
					type: 'checkbox',
					wrapperClass: 'col-w100-chbox chbox_style-wrapper',
					className: 'mw-500px',
					prop: 'differentPermanentAddress',
				}"
				type="contracting"
				class="checkbox-center"
			/>
		</div>
		<div
			class="input-wrapper mb-20px"
			style="background-color: #f4f5f4"
			v-if="getCheckboxData('differentPermanentAddress')"
		>
			<div class="input__title">Szerződő állandó lakcíme:</div>
			<InputField :elements="permanentAddress" refGroup="baseData-permanentAddress" />
		</div>
		<div class="input-wrapper no-p-top">
			<CalcElem
				name="differentMailingAddress"
				:options="{
					label: 'A szerződő levelezési címe eltér az állandótól',
					type: 'checkbox',
					wrapperClass: 'col-w100-chbox chbox_style-wrapper',
					className: 'mw-500px',
					prop: 'differentMailingAddress',
				}"
				type="contracting"
				class="checkbox-center"
			/>
		</div>
		<div
			class="input-wrapper mb-20px"
			style="background-color: #f4f5f4"
			v-if="getCheckboxData('differentMailingAddress')"
		>
			<div class="input__title">Szerződő levelezési címe:</div>
			<InputField :elements="mailingAddress" refGroup="baseData-mailingAddress" />
		</div>
		<div class="input-wrapper no-p-top">
			<CalcElem
				name="differentInsuredData"
				:options="{
					label: 'A biztosított adatai eltérnek a fentiektől',
					type: 'checkbox',
					wrapperClass: 'col-w100-chbox chbox_style-wrapper',
					className: 'mw-500px',
					prop: 'differentInsuredData',
				}"
				type="contracting"
				class="checkbox-center"
			/>
		</div>
	</div>
</template>

<script>
import _, {cloneDeep} from 'lodash';
import dataPages from '@/mixins/dataPages';
import baseData from '@/mixins/baseData';
import beneficiary from '@/mixins/beneficiary';
import { mapGetters, mapMutations } from 'vuex';

export default {
	mixins: [dataPages, baseData, beneficiary],
	data() {
		return {
			insurer: 'alfa',
			type: 'baseData',
		};
	},
	computed: {
		...mapGetters(['getCalculation','getRealEstate']),
        ...mapGetters('contracting', ['getCheckboxes']),
        mailingAddress() {
            const data = cloneDeep(this.fields.mailingAddress);
            if(this.getCheckboxes.mailingAddressNotHasHouseNumber) {
                delete data.from_house_number;
                delete data.dash;
                delete data.to_house_number;
            } else {
                delete data.parcel_number;
            }
            return data;
        },
        permanentAddress() {
            const data = cloneDeep(this.fields.permanentAddress);
            if(this.getCheckboxes.permanentAddressNotHasHouseNumber) {
                delete data.from_house_number;
                delete data.dash;
                delete data.to_house_number;
            } else {
                delete data.parcel_number;
            }
            return data;
        },

	},
	methods: {
		...mapMutations('contracting', ['setCheckboxData']),
        beforePrevAfter() {
            console.log("called happy");
            if(this.getCheckboxData('differentMailingAddress') && !this.getCheckboxes.mailingAddressNotHasHouseNumber) {
                this.setFormData({
                    parent: "baseData",
                    group: "mailingAddress",
                    prop: "parcel_number",
                    value: null,
                });
            } else if(this.getCheckboxData('differentPermanentAddress') && this.getCheckboxes.mailingAddressNotHasHouseNumber) {
                this.setFormData({
                    parent: "baseData",
                    group: "mailingAddress",
                    prop: "from_house_number",
                    value: null,
                });
                this.setFormData({
                    parent: "baseData",
                    group: "mailingAddress",
                    prop: "to_house_number",
                    value: null,
                });
            }

            if(this.getCheckboxData('differentPermanentAddress') && !this.getCheckboxes.permanentAddressNotHasHouseNumber) {
                this.setFormData({
                    parent: "baseData",
                    group: "permanentAddress",
                    prop: "parcel_number",
                    value: null,
                });
            } else if(this.getCheckboxData('differentPermanentAddress') && this.getCheckboxes.permanentAddressNotHasHouseNumber) {
                this.setFormData({
                    parent: "baseData",
                    group: "permanentAddress",
                    prop: "from_house_number",
                    value: null,
                });
                this.setFormData({
                    parent: "baseData",
                    group: "permanentAddress",
                    prop: "to_house_number",
                    value: null,
                });
            }
        }
	},
};
</script>
